module.exports = __webpack_public_path__ + "img/15_0.f3061bae.png";